const CONTROLLER = '/auth';
const PATHS = {
  CREATE_NEW_PASSWORD: '/create-password',

  REQUEST_PASSWORD_RECOVER: '/password-reset/request',
  VALIDATE_RESET_TOKEN: '/password-reset/validate',
  RESET_PASSWORD: '/password-reset/confirm',
};

export const PasswordApiRoutesNames = Object.fromEntries(
  (Object.keys(PATHS) as Array<keyof typeof PATHS>).map((k) => [k, k]),
) as {
  [K in keyof typeof PATHS]: K;
};

export const PasswordApiRoutes = {
  CONTROLLER,
  PATHS,
  CREATE_NEW_PASSWORD: (token: string | undefined) =>
    `${CONTROLLER}${PATHS.CREATE_NEW_PASSWORD}?token=${String(token)}`,

  REQUEST_PASSWORD_RECOVER: `${CONTROLLER}${PATHS.REQUEST_PASSWORD_RECOVER}`,
  VALIDATE_RESET_TOKEN: (token: string | undefined) =>
    `${CONTROLLER}${PATHS.VALIDATE_RESET_TOKEN}?token=${String(token)}`,
  RESET_PASSWORD: (token: string | undefined) =>
    `${CONTROLLER}${PATHS.RESET_PASSWORD}?token=${String(token)}`,
};
